import type { ComponentProps } from 'react';

import type { FieldLayoutOptions } from './useFieldLayout';
import { FormCreatableSelect } from './FormField';
import { useFieldLayout } from './useFieldLayout';

type CreatableSelectFieldProps = Omit<
  ComponentProps<typeof FormCreatableSelect>,
  'label' | 'inputHeight' | 'inputBackground'
> &
  FieldLayoutOptions;

export const CreatableSelectField = ({
  label,
  hideLabel,
  ...fieldProps
}: CreatableSelectFieldProps) => {
  const field = useFieldLayout({ label, hideLabel });

  return (
    <FormCreatableSelect
      label={field.label}
      aria-label={field.ariaLabel}
      inputHeight={field.inputHeight}
      inputBackground={field.inputBackground}
      {...fieldProps}
    />
  );
};
